export default "__VITE_ASSET__BoCp$uNo__"